export default {
  "nav.services": "Services",
  "nav.jurisdictions": "Countries",
  "nav.partnerNetwork": "Partner Network",
  "nav.process": "Process",
  "nav.blog": "Blog",
  "nav.contact": "Contact",
  "nav.admin": "Admin",
  "nav.signIn": "Sign In",
  "nav.getFreeAnalysis": "Get Free Analysis",
  "nav.dashboard": "Dashboard",

  "footer.services": "SERVICES",
  "footer.companyFormation": "Company Formation",
  "footer.visaImmigration": "Visa & Immigration",
  "footer.businessExpansion": "Business Expansion",
  "footer.legalPartnerNetwork": "Legal Partner Network",
  "footer.investmentAdvisory": "Investment Advisory",
  "footer.jurisdictions": "COUNTRIES",
  "footer.germany": "Germany (GmbH)",
  "footer.uk": "United Kingdom (Ltd)",
  "footer.usa": "USA (LLC/C-Corp)",
  "footer.dubai": "Dubai (Free Zone)",
  "footer.estonia": "Estonia (e-Residency)",
  "footer.legal": "LEGAL",
  "footer.company": "COMPANY",
  "footer.about": "About LegalVio",
  "footer.ourProcess": "Our Process",
  "footer.faq": "FAQ",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  "footer.contact": "Contact",
  "footer.cookiePolicy": "Cookie Policy",
  "footer.kvkk": "KVKK Disclosure",
  "footer.disclaimer": "Legal Disclaimer",
  "footer.whyLegalVio": "Why LegalVio",
  "footer.support": "Support Center",
  "footer.netherlands": "Netherlands (BV)",
  "footer.ireland": "Ireland (Ltd)",
  "footer.careers": "Careers",
  "footer.copyright": "All rights reserved.",
  "footer.description": "AI-powered global LegalTech platform. International company formation, visa services, and business expansion consulting across 150+ countries. Your global legal coordination partner.",
  "footer.newsletterTitle": "Stay Informed",
  "footer.newsletterDesc": "Get the latest updates on international business, legal developments, and expansion strategies.",
  "footer.newsletterPlaceholder": "Your email address",
  "footer.newsletterButton": "Subscribe",
  "footer.newsletterSuccess": "Thank you for subscribing!",
  "footer.newsletterError": "Something went wrong. Please try again.",
  "footer.contactTitle": "CONTACT US",
  "footer.contactDesc": "Reach us 24/7 via WhatsApp for any questions. Our team will get back to you shortly.",
  "footer.contactSupportNote": "24/7 WhatsApp support — Average response time: 5 minutes",
  "footer.contactNotConfigured": "Contact details not yet configured.",

  "cookie.title": "Cookie Preferences",
  "cookie.description": "We use cookies to provide you with a better experience, deliver personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
  "cookie.acceptAll": "Accept All",
  "cookie.essentialOnly": "Essential Only",
  "cookie.customize": "Customize",
  "cookie.essential": "Essential Cookies",
  "cookie.essentialDesc": "These cookies are necessary for the website to function and cannot be turned off.",
  "cookie.analytics": "Analytics Cookies",
  "cookie.analyticsDesc": "These cookies help us improve our website's performance by measuring visits and traffic sources.",
  "cookie.marketing": "Marketing Cookies",
  "cookie.marketingDesc": "These cookies may be set through our site by our advertising partners to build a profile of your interests.",
  "cookie.savePreferences": "Save Preferences",

  "privacy.title": "Privacy Policy",
  "terms.title": "Terms of Service",
  "cookies.title": "Cookie Policy",

  "common.home": "Home",
  "common.loading": "Loading...",
  "common.error": "Something went wrong",
  "common.retry": "Try Again",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.submit": "Submit",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.clear": "Clear",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.details": "Details",
  "common.learnMore": "Learn More",
  "common.contactUs": "Contact Us",
  "common.getStarted": "Get Started",
  "common.viewAll": "View All",
  "common.noResults": "No results found",
  "common.showMore": "Show More",
  "common.showLess": "Show Less",
  "common.searchPlaceholder": "Search pages, tabs, or actions...",
  "common.selectItem": "Select",
  "common.close": "Close",
  "common.delete": "Delete",
  "common.confirmDelete": "Are you sure you want to delete?",
  "common.yesDelete": "Yes, Delete",
  "common.deleting": "Deleting...",
  "common.deleted": "Deleted!",

  "home.heroTitle": "Your Global Legal Intelligence Network",
  "home.heroSubtitle": "AI-powered platform for international company formation, visa services, and business expansion. One platform, 150+ countries, 300+ vetted law firms.",
  "home.heroCTA": "Get Free Analysis",
  "home.heroSecondary": "Explore Services",
  "home.servicesTitle": "Core Services",
  "home.servicesSubtitle": "Everything you need to grow your business globally, powered by AI and a network of expert law firms.",
  "home.statsTitle": "Trusted Worldwide",
  "home.processTitle": "How It Works",
  "home.partnersTitle": "Global Partner Network",
  "home.testimonialsTitle": "Client Success Stories",

  "services.heroTitle": "World-Class Legal Services, One Platform",
  "services.heroSubtitle": "From company formation to visa processing and business expansion, LegalVio coordinates every stage of your international journey.",
  "services.companyFormation": "International Company Formation",
  "services.visaImmigration": "Visa & Immigration Services",
  "services.businessExpansion": "Business Expansion Consulting",
  "services.moreSolutions": "More Solutions",
  "services.comprehensiveEcosystem": "Comprehensive Legal Ecosystem",
  "services.readyToGoGlobal": "Ready to Go Global?",
  "services.readyDesc": "Get a free, no-obligation analysis for your international expansion needs.",

  "language.en": "English",
  "language.tr": "Türkçe",
  "language.de": "Deutsch",
  "language.fr": "Français",
  "language.es": "Español",
  "language.it": "Italiano",
  "language.ar": "العربية",
  "language.ru": "Русский",
  "language.zh": "中文",
  "language.ja": "日本語",
  "language.ko": "한국어",

  "home.heroBadge": "AI-Powered LegalTech Platform",
  "home.heroHeadline1": "Global Corporate",
  "home.heroHeadline2": "Legal Intelligence",
  "home.heroHeadline3": "Network",
  "home.heroDescription": "AI-powered business coordination for 150+ countries, 300+ partner law firms, global company formation, and immigration solutions. Your single door to international legal services.",
  "home.heroCTA1": "Explore Countries",
  "home.heroCTA2": "Get Free Analysis",
  "home.heroTrusted": "Trusted by 2,000+ clients",
  "home.heroCompliant": "GDPR & KVKK Compliant",
  "home.heroAvgResponse": "Avg. Response Time",
  "home.heroCountriesCovered": "Countries Covered",
  "home.heroPartnerFirms": "Partner Law Firms",
  "home.heroSuccessRate": "Success Rate",
  "home.heroCompaniesFormed": "Companies Formed",

  "faq.helpCenter": "Help Center",
  "faq.heroTitle1": "Frequently Asked",
  "faq.heroTitle2": "Questions",
  "faq.heroDesc": "Everything you need to know about LegalVio's services, process, and platform. Can't find what you're looking for? Our team is ready to help.",
  "faq.cat.0": "Company Formation",
  "faq.cat.1": "Visa & Immigration",
  "faq.cat.2": "Business Expansion",
  "faq.cat.3": "Platform & Partnership",
  "faq.cat.4": "LegalTech & AI",
  "faq.cat.5": "Compliance & Data Privacy",
  "faq.stillHaveQuestions": "Still Have Questions?",
  "faq.stillHaveDesc": "Our expert team is ready to help. Contact us and we'll get back to you within 4 hours.",
  "faq.contactUs": "Contact Us",
  "faq.exploreServices": "Explore Services",

  "svc.heroBadge": "Global Legal Services",
  "svc.heroTitle1": "World-Class Legal Services,",
  "svc.heroTitle2": "One Platform",
  "svc.heroDesc": "From company formation to visa processing and business expansion, LegalVio coordinates every stage of your international journey with AI precision and a network of {{count}}+ vetted law firms.",
  "svc.formationTitle": "International Company Formation",
  "svc.formationSubtitle": "Establish your business anywhere in the world",
  "svc.formationDesc": "Full-service company formation across 150+ countries. From GmbH in Germany to LLC in the USA, our vetted local partners handle all legal details while our AI platform coordinates the entire process.",
  "svc.visaTitle": "Visa & Immigration Services",
  "svc.visaSubtitle": "Navigate your global immigration journey with confidence",
  "svc.visaDesc": "Expert guidance for investor visas, startup visas, work permits, and Golden Visa programs. Our AI-powered matching system connects you with immigration specialists best suited to your situation.",
  "svc.expansionTitle": "Business Expansion Consulting",
  "svc.expansionSubtitle": "Take your business across borders",
  "svc.expansionDesc": "Market entry strategy, international compliance, corporate structuring, and investment advisory. We help you navigate complex regulatory environments and identify growth opportunities worldwide.",
  "svc.countries": "Countries",
  "svc.formed": "Formed",
  "svc.partners": "Partners",
  "svc.approved": "Approved",
  "svc.markets": "Markets",
  "svc.clients": "Clients",
  "svc.learnMore": "Learn More",
  "svc.moreSolutions": "More Solutions",
  "svc.comprehensiveEcosystem": "Comprehensive Legal Ecosystem",
  "svc.comprehensiveDesc": "Beyond our core services, LegalVio offers complementary solutions for your global business needs.",
  "svc.legalPartnerNetwork": "Legal Partner Network",
  "svc.legalPartnerNetworkDesc": "Access {{count}}+ vetted law firms worldwide for cross-border legal coordination and expert consultation.",
  "svc.investmentAdvisory": "Investment Advisory",
  "svc.investmentAdvisoryDesc": "Strategic investment guidance for international ventures, mergers & acquisitions, and cross-border transactions.",
  "svc.complianceManagement": "Compliance Management",
  "svc.complianceManagementDesc": "Continuous regulatory compliance monitoring across all regions where you operate.",
  "svc.marketResearch": "Market Research",
  "svc.marketResearchDesc": "Data-driven market analysis and entry feasibility studies for international expansion.",
  "svc.readyGlobal": "Ready to Go Global?",
  "svc.readyGlobalDesc": "Get a free, no-obligation analysis for your international expansion needs. Our AI-powered system matches you with the optimal solution within 24 hours.",
  "svc.getFreeAnalysis": "Get Free Analysis",
  "svc.viewProcess": "View Our Process",

  "cf.breadcrumb": "Services",
  "cf.badge": "Core Service",
  "cf.heroTitle1": "International",
  "cf.heroTitle2": "Company Formation",
  "cf.heroDesc": "Establish your business with our network of vetted local law firms across 150+ countries. From GmbH in Germany to LLC in the USA, we handle all legal details while you focus on growth.",
  "cf.startFormation": "Start Your Formation",
  "cf.exploreCountries": "Explore Countries",
  "cf.statCountries": "Countries",
  "cf.statFormed": "Companies Formed",
  "cf.statPartners": "Partner Firms",
  "cf.popularJurisdictions": "Popular Jurisdictions",
  "cf.chooseDestination": "Choose Your Destination",
  "cf.chooseDesc": "Each jurisdiction offers unique advantages. Our AI-powered system helps you find the best match for your business needs.",
  "cf.minCapital": "Min. Capital",
  "cf.timeline": "Timeline",
  "cf.processTitle": "Our Process",
  "cf.howItWorks": "How Company Formation Works",
  "cf.howDesc": "A streamlined process managed by our AI platform and executed by local legal experts.",
  "cf.step1Title": "Initial Consultation",
  "cf.step1Desc": "We analyze your business goals and recommend the optimal jurisdiction and company type.",
  "cf.step2Title": "Documentation",
  "cf.step2Desc": "Our partners prepare all necessary documents. You review and provide the required information.",
  "cf.step3Title": "Registration",
  "cf.step3Desc": "The local law firm submits the registration application to the competent authorities. We track progress in real-time.",
  "cf.step4Title": "Post-Formation",
  "cf.step4Desc": "Bank account opening, tax registration, and ongoing compliance support are arranged.",
  "cf.faqTitle": "Frequently Asked Questions",
  "cf.ctaTitle": "Ready to Form Your Company?",
  "cf.ctaDesc": "Get a free consultation from our company formation experts. Let us help you choose the right jurisdiction and structure for your business.",
  "cf.ctaButton": "Get Free Consultation",
  "cf.countryStartNow": "Start in this country",
  "cf.midCTATitle": "Start forming your business today",
  "cf.midCTADesc": "Our expert team handles the entire legal process for you. You just focus on growth.",
  "cf.midCTAButton": "Start Now",
  "cf.faqStillQuestions": "Didn't find the answer you're looking for?",
  "cf.faqContactDesc": "Our expert team is ready to answer all your questions.",
  "cf.faqContactButton": "Contact Us",

  "vi.breadcrumb": "Services",
  "vi.badge": "Core Service",
  "vi.heroTitle1": "Visa &",
  "vi.heroTitle2": "Immigration Services",
  "vi.heroDesc": "Navigate your global immigration journey with confidence. From investor Golden Visas to startup and digital nomad programs, our AI-powered platform connects you with the ideal pathway and vetted immigration specialists.",
  "vi.startApplication": "Start Your Application",
  "vi.explorePrograms": "Explore Programs",
  "vi.statCountries": "Countries",
  "vi.statApproved": "Visas Approved",
  "vi.statSuccessRate": "Success Rate",
  "vi.visaPrograms": "Visa Programs",
  "vi.findPathway": "Find Your Immigration Pathway",
  "vi.findPathwayDesc": "From investment-based residency to startup and digital nomad programs, discover options that match your profile.",
  "vi.investment": "Investment",
  "vi.immigrationJourney": "Your Immigration Journey",
  "vi.immigrationJourneyDesc": "A comprehensive six-step process managed by immigration specialists and powered by our AI platform.",
  "vi.step1Title": "Eligibility Assessment",
  "vi.step1Desc": "Our AI system evaluates your profile against visa program requirements and identifies the best options.",
  "vi.step2Title": "Document Collection",
  "vi.step2Desc": "We provide a comprehensive checklist and assist in gathering all required documents.",
  "vi.step3Title": "Application Preparation",
  "vi.step3Desc": "Local immigration lawyers prepare and review your application package for maximum success rate.",
  "vi.step4Title": "Submission & Follow-up",
  "vi.step4Desc": "The application is submitted to the relevant authorities. We track progress and manage follow-up requests.",
  "vi.step5Title": "Visa Issuance",
  "vi.step5Desc": "Upon approval, we assist with visa processing and guide you through the settlement process.",
  "vi.step6Title": "Post-Arrival Support",
  "vi.step6Desc": "Ongoing assistance for residence permits, tax registration, and local integration.",
  "vi.faqTitle": "Immigration Questions",
  "vi.ctaTitle": "Start Your Immigration Journey",
  "vi.ctaDesc": "Book a free consultation with our immigration specialists. Let's assess your eligibility and recommend the best visa pathway for your goals.",
  "vi.ctaButton": "Get Free Assessment",

  "be.breadcrumb": "Services",
  "be.badge": "Core Service",
  "be.heroTitle1": "Business",
  "be.heroTitle2": "Expansion Consulting",
  "be.heroDesc": "Take your business across borders with confidence. From market entry strategy to compliance and corporate structuring, our network of 100+ market experts ensures your international expansion succeeds.",
  "be.scheduleConsultation": "Schedule Consultation",
  "be.exploreServices": "Explore Services",
  "be.statMarkets": "Markets Covered",
  "be.statProjects": "Expansion Projects",
  "be.statRetention": "Client Retention",
  "be.statValue": "Client Value Created",
  "be.ourExpertise": "Our Expertise",
  "be.comprehensiveSolutions": "Comprehensive Expansion Solutions",
  "be.comprehensiveDesc": "End-to-end consulting services for every stage of your international growth journey.",
  "be.inquire": "Inquire About This Service",
  "be.whatsIncluded": "What's Included",
  "be.whyLegalVio": "Why LegalVio",
  "be.advantage": "The LegalVio Advantage",
  "be.advantageDesc": "What sets our expansion consulting apart from traditional approaches.",
  "be.advantage1Title": "AI-Powered Analysis",
  "be.advantage1Desc": "Our platform processes market data, regulatory changes, and competitive intelligence to deliver actionable insights faster than traditional consulting.",
  "be.advantage2Title": "100+ Market Network",
  "be.advantage2Desc": "Access vetted experts in every major global market. No need to work with multiple consultants across different regions.",
  "be.advantage3Title": "Accelerated Timeline",
  "be.advantage3Desc": "Reduce market entry time by 40-60% through parallel workflows coordinated by our AI platform and local partners.",
  "be.advantage4Title": "Risk Mitigation",
  "be.advantage4Desc": "Proactive compliance monitoring and risk assessment across all regions, reducing exposure to regulatory penalties.",
  "be.faqTitle": "Expansion Questions",
  "be.ctaTitle": "Let's Expand Together",
  "be.ctaDesc": "Book a free strategy session with our expansion experts. Let's analyze your business goals and build a customized international growth plan.",
  "be.ctaButton": "Book Strategy Session",

  "pn.badge": "Global Legal Network",
  "pn.heroTitle1": "Partner Law Firm",
  "pn.heroTitle2": "Network",
  "pn.heroDesc": "{{count}}+ vetted law firms across {{countries}}+ countries. Our AI-powered matching system connects you with the right legal partner for your specific needs, region, and industry.",
  "pn.statFirms": "Partner Firms",
  "pn.statCountries": "Countries",
  "pn.statPracticeAreas": "Practice Areas",
  "pn.statCoordination": "Coordination",
  "pn.globalPresence": "Our Global Presence",
  "pn.globalPresenceDesc": "Partner law firms strategically positioned in every major financial and business hub worldwide.",
  "pn.coverageTitle": "Coverage by Region",
  "pn.coverageDesc": "Our network spans all continents with a strong presence in every major business region.",
  "pn.countries": "Countries",
  "pn.firms": "Firms",
  "pn.directoryTitle": "Partner Directory",
  "pn.directoryDesc": "Explore our network of vetted partner law firms worldwide.",
  "pn.allPracticeAreas": "All Practice Areas",
  "pn.partnerFound": "partner found",
  "pn.partnersFound": "partners found",
  "pn.viewProfile": "View Profile",
  "pn.contact": "Contact",
  "pn.joinNetwork": "Join Our Network",
  "pn.partnerWithUs": "Partner with LegalVio",
  "pn.partnerDesc": "Are you a law firm looking to expand your international client base? Join the LegalVio partner network and gain access to a global stream of qualified client referrals.",
  "pn.benefit1": "Access to international client referrals",
  "pn.benefit2": "AI-powered case matching for your expertise",
  "pn.benefit3": "White-label partnership options",
  "pn.benefit4": "Revenue-sharing referral model",
  "pn.benefit5": "Co-branded marketing opportunities",
  "pn.applyAsPartner": "Apply as Partner",
  "pn.findPartner": "Find Your Legal Partner",
  "pn.findPartnerDesc": "Tell us what you need, and our AI-powered system will match you with the ideal partner law firm from our global network.",
  "pn.getMatched": "Get Matched Now",
  "pn.noPartnersYet": "No partners added yet. Use the admin panel to add partners.",

  "pa.title": "Partner Application",
  "pa.desc": "Join LegalVio's global network of trusted law firms. Fill out the form below and our team will review your application.",
  "pa.firmInfo": "Firm Information",
  "pa.firmName": "Firm Name",
  "pa.practiceAreas": "Practice Areas",
  "pa.country": "Country",
  "pa.city": "City",
  "pa.website": "Website",
  "pa.lawyerCount": "Number of Lawyers",
  "pa.selectCountry": "Select country",
  "pa.contactPerson": "Contact Person",
  "pa.fullName": "Full Name",
  "pa.email": "Email",
  "pa.phone": "Phone",
  "pa.aboutFirm": "About Your Firm",
  "pa.aboutPlaceholder": "Tell us about your firm's expertise, notable cases, and why you want to join the LegalVio network...",
  "pa.submit": "Submit Application",
  "pa.submitting": "Submitting...",
  "pa.successTitle": "Application Submitted!",
  "pa.successDesc": "Thank you for your interest in joining the LegalVio partner network. Our team will review your application and get back to you within 3-5 business days.",
  "pa.goDashboard": "Go to Dashboard",
  "pa.viewPartnerNetwork": "View Partner Network",
  "pa.errorFillRequired": "Please fill all required fields and select at least one practice area.",

  "stats.countries": "Countries",
  "stats.partnerFirms": "Partner Law Firms",
  "stats.companiesFormed": "Companies Formed",
  "stats.clientSatisfaction": "Client Satisfaction",
  "stats.avgResponse": "Avg. Response Time",
  "stats.languages": "Languages Supported",

  "home.servicesBadge": "Our Services",
  "home.servicesTitleFull": "End-to-End Global Legal Services",
  "home.servicesDesc": "From company formation to visa processing, our AI-powered platform coordinates every stage of your international expansion with vetted local partners.",

  "home.processBadge": "How It Works",
  "home.processTitleFull": "Your Global Expansion Journey",
  "home.processDesc": "A seamless six-step process from initial request to ongoing international business support.",
  "home.prStep1Title": "Submit Request",
  "home.prStep1Desc": "Fill out a simple form detailing your business goals, target country, and service needs.",
  "home.prStep2Title": "Free Analysis",
  "home.prStep2Desc": "Our AI-powered system analyzes your requirements and matches you with the optimal solutions.",
  "home.prStep3Title": "Country & Service Matching",
  "home.prStep3Desc": "We identify the best jurisdiction and service package tailored to your specific needs.",
  "home.prStep4Title": "Partner Law Firm Assignment",
  "home.prStep4Desc": "You're connected with a vetted local partner law firm specializing in your requirements.",
  "home.prStep5Title": "Formation / Visa Process",
  "home.prStep5Desc": "The partner firm handles all legal procedures while we coordinate and track progress.",
  "home.prStep6Title": "Post-Process Support",
  "home.prStep6Desc": "Ongoing compliance, accounting, and legal support for your international operations.",

  "home.jurBadge": "Jurisdictions",
  "home.jurTitle": "Explore 150+ Jurisdictions",
  "home.jurDesc": "From Turkey to Dubai, Estonia to the USA — find the optimal jurisdiction for your business.",
  "home.jurPopular": "Popular",

  "home.partnersBadge": "Global Partner Network",
  "home.partnersTitle": "300+ Vetted Partner Law Firms Worldwide",
  "home.partnersDesc": "Our carefully selected network of legal partners spans six continents. Each firm is rigorously vetted for expertise, reliability, and local market knowledge — ensuring you receive world-class service wherever you operate.",
  "home.becomePartner": "Become a Partner Law Firm",

  "home.testimonialsBadge": "Verified Partner Review",
  "home.testimonialsLabel": "Client Success Stories",

  "home.ctaTitle": "Ready to go global?",
  "home.ctaDesc": "Get a free, no-obligation analysis for your international expansion needs. Our AI-powered system will match you with the optimal jurisdiction and legal partner.",
  "home.ctaConfidential": "Confidential & Secure",
  "home.ctaResponse": "Response within 4 hours",
  "home.ctaLanguages": "Service in 11 languages",
  "home.ctaFormTitle": "Get Your Free Analysis",
  "home.ctaFormDesc": "Fill out the form and our team will get back to you within 4 hours.",
  "home.ctaFormName": "Full Name",
  "home.ctaFormEmail": "Email",
  "home.ctaFormPhone": "Phone",
  "home.ctaFormCountry": "Target Country",
  "home.ctaFormService": "Service Needed",
  "home.ctaFormMessage": "Message",
  "home.ctaFormMessagePlaceholder": "Tell us about your international expansion needs...",
  "home.ctaFormSubmitted": "Request Submitted!",
  "home.ctaFormSubmittedDesc": "We'll get back to you within 4 hours. Thank you for choosing LegalVio.",
  "home.ctaFormError": "Something went wrong. Please try again.",
  "home.ctaFormNetworkError": "Network error. Please check your connection and try again.",
  "home.ctaFormCharLimit": "Message cannot exceed 500 characters.",

  "auth.welcomeBack": "Welcome Back",
  "auth.signInDesc": "Sign in to access your dashboard and requests.",
  "auth.emailAddress": "Email Address",
  "auth.password": "Password",
  "auth.enterPassword": "Enter your password",
  "auth.signIn": "Sign In",
  "auth.signingIn": "Signing in...",
  "auth.noAccount": "Don't have an account?",
  "auth.createAccount": "Create Account",
  "auth.createYourAccount": "Create Your Account",
  "auth.signupDesc": "Start your global expansion journey with LegalVio.",
  "auth.fullName": "Full Name",
  "auth.confirmPassword": "Confirm Password",
  "auth.repeatPassword": "Re-enter your password",
  "auth.min6Chars": "At least 6 characters",
  "auth.creatingAccount": "Creating account...",
  "auth.haveAccount": "Already have an account?",
  "auth.fillAllFields": "Please fill in all fields.",
  "auth.passwordMin6": "Password must be at least 6 characters.",
  "auth.passwordsDontMatch": "Passwords don't match.",
  "auth.unexpectedError": "An unexpected error occurred. Please try again.",

  "cta.title": "Ready to go global?",
  "cta.description": "Get a free, no-obligation analysis for your international expansion needs. Our AI-powered system will match you with the optimal jurisdiction and legal partner.",
  "cta.confidential": "Confidential & Secure",
  "cta.response": "Response within 4 hours",
  "cta.languages": "Service in 11 languages",
  "cta.formTitle": "Get Your Free Analysis",
  "cta.formDesc": "Fill out the form and our team will get back to you within 4 hours.",
  "cta.formName": "Full Name *",
  "cta.formEmail": "Email *",
  "cta.formPhone": "Phone",
  "cta.formCountry": "Target Country *",
  "cta.formService": "Service Needed *",
  "cta.formMessage": "Message",
  "cta.formMessagePlaceholder": "Tell us about your international expansion needs...",
  "cta.formSelectCountry": "Select country",
  "cta.formSelectService": "Select service",
  "cta.formSubmitted": "Request Submitted!",
  "cta.formSubmittedDesc": "We'll get back to you within 4 hours. Thank you for choosing LegalVio.",
  "cta.formError": "Something went wrong. Please try again.",
  "cta.formNetworkError": "Network error. Please check your connection and try again.",
  "cta.formCharLimit": "Message cannot exceed 500 characters.",
  "cta.submitting": "Submitting...",
  "cta.getFreeAnalysis": "Get Free Analysis",

  "partners.badge": "Global Partner Network",
  "partners.titleLine1": "300+ Vetted",
  "partners.titleLine2": "Partner Law Firms Worldwide",
  "partners.description": "Our carefully selected network of legal partners spans six continents. Each firm is rigorously vetted for expertise, reliability, and local market knowledge — ensuring you receive world-class service wherever you operate.",
  "partners.becomePartner": "Become a Partner Law Firm",

  "dash.welcomeBack": "Welcome back,",
  "dash.trackJourney": "Track your global expansion journey and manage service requests.",
  "dash.totalRequests": "Total Requests",
  "dash.pending": "Pending",
  "dash.inProgress": "In Progress",
  "dash.completed": "Completed",
  "dash.newRequest": "New Service Request",
  "dash.viewAllRequests": "View All Requests",
  "dash.recentRequests": "Recent Requests",
  "dash.viewAll": "View All",
  "dash.loadingRequests": "Loading requests...",
  "dash.failedToLoad": "Failed to load requests.",
  "dash.tryAgain": "Try Again",
  "dash.noRequests": "No requests yet",
  "dash.noRequestsDesc": "Create your first service request and start your global expansion journey.",
  "dash.createRequest": "Create Request",
  "dash.viewDetails": "View Details",
  "dash.service": "Service",
  "dash.country": "Country",
  "dash.status": "Status",
  "dash.date": "Date",
  "dash.action": "Action",
  "dash.myRequests": "My Requests",
  "dash.profile": "Profile",
  "dash.signOut": "Sign Out",
  "dash.cancelled": "Cancelled",
  "dash.userFallback": "welcome",
  "dash.documents": "Documents",

  "admin.dashboard": "Dashboard",
  "admin.requests": "Requests",
  "admin.users": "Users",
  "admin.applications": "Applications",
  "admin.blog": "Blog",
  "admin.faq": "FAQ",
  "admin.partners": "Partners",
  "admin.testimonials": "Testimonials",
  "admin.audit": "Audit Log",
  "admin.settings": "Settings",
  "admin.jurisdictions": "Jurisdictions",
  "admin.adminPanel": "Admin Panel",
  "admin.manageDesc": "Manage requests, users, and partner applications.",
  "admin.loadingData": "Loading data...",
  "admin.failedToLoad": "Failed to load data.",
  "admin.retry": "Try Again",
  "admin.signOut": "Sign Out",
  "admin.tabs.dashboard": "Dashboard",
  "admin.tabs.requests": "Requests",
  "admin.tabs.users": "Users",
  "admin.tabs.applications": "Applications",
  "admin.tabs.blog": "Blog",
  "admin.tabs.faq": "FAQ",
  "admin.tabs.partners": "Partners",
  "admin.tabs.testimonials": "Testimonials",
  "admin.tabs.audit": "Audit Log",
  "admin.tabs.settings": "Settings",
  "admin.tabs.jurisdictions": "Jurisdictions",
  "admin.tabs.pricing": "Pricing",
  "admin.tabs.documents": "Documents",
  "admin.tabs.serviceContent": "Service Content",
  "admin.tabs.notifications": "Notifications",
  "admin.tabs.seo": "SEO Management",
  "admin.tabs.schemas": "Schema Management",
  "admin.tabs.navigation": "Menu Management",
  "admin.tabs.geo": "GEO Management",
  "admin.tabs.aiVisibility": "AI Visibility",
  "admin.tabs.media": "Media Library",
  "admin.tabs.emailTemplates": "Email Templates",
  "admin.tabs.analytics": "Analytics Reports",
  "admin.tabs.templateLibrary": "Template Library",
  "admin.tabs.footerManagement": "Footer Management",
  "admin.tabs.headerManagement": "Header Management",
  "admin.tabs.linkHealth": "Link Health",
  "admin.status.pending": "Pending",
  "admin.status.inProgress": "In Progress",
  "admin.status.completed": "Completed",
  "admin.status.cancelled": "Cancelled",
  "admin.status.approved": "Approved",
  "admin.status.rejected": "Rejected",
  "admin.service.companyFormation": "Company Formation",
  "admin.service.visaImmigration": "Visa & Immigration",
  "admin.service.businessExpansion": "Business Expansion",
  "admin.service.legalConsulting": "Legal Consulting",
  "admin.common.manage": "Manage",
  "admin.common.save": "Save Changes",
  "admin.common.cancel": "Cancel",
  "admin.common.create": "Create",
  "admin.common.delete": "Delete",
  "admin.common.close": "Close",
  "admin.common.search": "Search",
  "admin.common.clear": "Clear",
  "admin.common.showing": "Showing",
  "admin.common.of": "/",
  "admin.common.na": "N/A",
  "admin.common.notSpecified": "Not specified",
  "admin.common.noDescription": "No description",
  "admin.common.all": "All",
  "admin.common.saving": "Saving...",
  "admin.common.saved": "Saved!",
  "admin.common.loading": "Loading...",
  "admin.common.noResults": "No results found",
  "admin.requestModal.title": "Manage Request",
  "admin.requestModal.contactEmail": "Contact Email",
  "admin.requestModal.phone": "Phone",
  "admin.requestModal.showDetails": "Show all details",
  "admin.requestModal.hideDetails": "Hide details",
  "admin.requestModal.company": "Company",
  "admin.requestModal.description": "Description",
  "admin.requestModal.budget": "Budget",
  "admin.requestModal.timeline": "Timeline",
  "admin.requestModal.updateStatus": "Update Status",
  "admin.requestModal.adminNotes": "Admin Notes",
  "admin.requestModal.addNotes": "Add internal note...",
  "admin.appModal.title": "Manage Application",
  "admin.appModal.lawyers": "Lawyers",
  "admin.appModal.website": "Website",
  "admin.appModal.practiceAreas": "Practice Areas",
  "admin.appModal.firmDesc": "Firm Description",
  "admin.appModal.contactPerson": "Contact Person",
  "admin.appModal.name": "Name",
  "admin.appModal.email": "Email",
  "admin.appModal.phone": "Phone",
  "admin.appModal.updateStatus": "Update Status",
  "admin.appModal.adminNotes": "Admin Notes",
  "admin.appModal.addNotes": "Add internal note...",
  "admin.userModal.profileInfo": "Profile Info",
  "admin.userModal.requests": "Requests",
  "admin.userModal.fullName": "Full Name",
  "admin.userModal.email": "Email",
  "admin.userModal.company": "Company",
  "admin.userModal.phone": "Phone",
  "admin.userModal.country": "Country",
  "admin.userModal.role": "Role",
  "admin.userModal.joined": "Joined",
  "admin.userModal.noRequests": "This user has no requests.",
  "admin.userModal.unnamedUser": "Unnamed User",
  "admin.requestsTab.searchPlaceholder": "Search requests...",
  "admin.requestsTab.allServices": "All Services",
  "admin.requestsTab.allStatuses": "All Statuses",
  "admin.requestsTab.allCountries": "All Countries",
  "admin.requestsTab.noMatch": "No requests match the filters.",
  "admin.requestsTab.noRequests": "No requests found.",
  "admin.requestsTab.service": "Service",
  "admin.requestsTab.country": "Country",
  "admin.requestsTab.contact": "Contact",
  "admin.requestsTab.status": "Status",
  "admin.requestsTab.date": "Date",
  "admin.requestsTab.action": "Action",
  "admin.applicationsTab.searchPlaceholder": "Search firms, people, practice areas...",
  "admin.applicationsTab.allStatuses": "All Statuses",
  "admin.applicationsTab.allCountries": "All Countries",
  "admin.applicationsTab.noMatch": "No applications match the filters.",
  "admin.applicationsTab.noApps": "No partner applications found.",
  "admin.applicationsTab.firm": "Firm",
  "admin.applicationsTab.location": "Location",
  "admin.applicationsTab.practiceAreas": "Practice Areas",
  "admin.applicationsTab.contact": "Contact",
  "admin.applicationsTab.status": "Status",
  "admin.applicationsTab.action": "Action",
  "admin.applicationsTab.lawyers_one": "lawyer",
  "admin.applicationsTab.lawyers_other": "lawyers",
  "admin.applicationsTab.date": "Date",
  "admin.blogTab.searchPlaceholder": "Search posts...",
  "admin.blogTab.allCategories": "All Categories",
  "admin.blogTab.allStatuses": "All Statuses",
  "admin.blogTab.newPost": "New Post",
  "admin.blogTab.editPost": "Edit Blog Post",
  "admin.blogTab.createPost": "Create Post",
  "admin.blogTab.cancel": "Cancel",
  "admin.blogTab.saveChanges": "Save Changes",
  "admin.blogTab.title": "Title",
  "admin.blogTab.slug": "Slug",
  "admin.blogTab.excerpt": "Excerpt",
  "admin.blogTab.category": "Category",
  "admin.blogTab.status": "Status",
  "admin.blogTab.featured": "Featured",
  "admin.blogTab.author": "Author",
  "admin.blogTab.role": "Role",
  "admin.blogTab.avatar": "Avatar (initials)",
  "admin.blogTab.date": "Date",
  "admin.blogTab.readTime": "Read Time",
  "admin.blogTab.imageUrl": "Cover Image",
  "admin.blogTab.tags": "Tags (comma separated)",
  "admin.blogTab.relatedSlugs": "Related Post Slugs (comma separated)",
  "admin.blogTab.sections": "Sections",
  "admin.blogTab.addSection": "Add Section",
  "admin.blogTab.section_one": "Section {{n}}",
  "admin.blogTab.sectionHeading": "Section heading",
  "admin.blogTab.sectionContent": "Section content",
  "admin.blogTab.published": "Published",
  "admin.blogTab.draft": "Draft",
  "admin.blogTab.loading": "Loading blog posts...",
  "admin.blogTab.noMatch": "No posts match the filters.",
  "admin.blogTab.noPosts": "No blog posts yet.",
  "admin.blogTab.actions": "Actions",
  "admin.blogTab.deleteConfirm": "Are you sure you want to permanently delete this blog post?",
  "admin.blogTab.deleteFailed": "Delete failed",
  "admin.blogTab.saveFailed": "Save failed",
  "admin.blogTab.requiredFields": "Title, slug, and excerpt are required.",
  "admin.usersTab.searchPlaceholder": "Search users by name, email, company...",
  "admin.usersTab.user": "User",
  "admin.usersTab.company": "Company",
  "admin.usersTab.country": "Country",
  "admin.usersTab.requests": "Requests",
  "admin.usersTab.role": "Role",
  "admin.usersTab.joined": "Joined",
  "admin.usersTab.actions": "Actions",
  "admin.usersTab.details": "Details",
  "admin.usersTab.noMatch": "No users match the search.",
  "admin.usersTab.noUsers": "No users found.",
  "admin.usersTab.deleteUser": "Delete User",
  "admin.usersTab.deleteTitle": "Delete User?",
  "admin.usersTab.deleteDesc": "This action is irreversible. All data for this user will be permanently deleted.",
  "admin.usersTab.deleting": "Deleting...",
  "admin.blogTab.categories.0": "Company Formation",
  "admin.blogTab.categories.1": "Visa & Immigration",
  "admin.blogTab.categories.2": "Business Expansion",
  "admin.blogTab.categories.3": "LegalTech",
  "admin.blogTab.categories.4": "Compliance",

  "home.scroll": "Scroll Down",
  "home.scrollLeft": "Scroll left",
  "home.scrollRight": "Scroll right",

  "reqNew.title": "New Service Request",
  "reqNew.subtitle": "Tell us your needs and we'll assign the best partner for you.",
  "reqNew.myRequests": "My Requests",
  "reqNew.profile": "Profile",
  "reqNew.serviceType": "Service Type",
  "reqNew.targetCountry": "Target Country",
  "reqNew.companyName": "Company Name",
  "reqNew.email": "Email",
  "reqNew.phone": "Phone",
  "reqNew.description": "Description",
  "reqNew.budgetRange": "Budget Range",
  "reqNew.timeline": "Timeline",
  "reqNew.submit": "Submit Request",
  "reqNew.submitting": "Submitting...",
  "reqNew.characters": "characters",
  "reqNew.requiredFields": "Please fill in all required fields (Service Type, Country, Email, Description).",
  "reqNew.charLimit": "Description cannot exceed 500 characters.",
  "reqNew.unexpectedError": "An unexpected error occurred. Please try again.",
  "reqNew.successTitle": "Request Submitted!",
  "reqNew.successDesc": "Your service request has been created. Our team will review it and get back to you as soon as possible.",
  "reqNew.redirecting": "Redirecting to your requests...",
  "reqNew.selectCountry": "Select country...",
  "reqNew.selectBudget": "Select budget range...",
  "reqNew.selectTimeline": "Select timeline...",
  "reqNew.companyPlaceholder": "Your company or project name",
  "reqNew.emailPlaceholder": "you@company.com",
  "reqNew.phonePlaceholder": "+90 555 123 4567",
  "reqNew.descPlaceholder": "Describe your needs, goals, and any special requirements...",
  "reqNew.serviceCompanyFormation": "Company Formation",
  "reqNew.serviceVisaImmigration": "Visa & Immigration",
  "reqNew.serviceBusinessExpansion": "Business Expansion",
  "reqNew.serviceLegalConsulting": "Legal Consulting",
  "reqNew.budgetUnder5k": "Under €5,000",
  "reqNew.budget5k10k": "€5,000 - €10,000",
  "reqNew.budget10k25k": "€10,000 - €25,000",
  "reqNew.budget25k50k": "€25,000 - €50,000",
  "reqNew.budget50k100k": "€50,000 - €100,000",
  "reqNew.budgetOver100k": "Over €100,000",
  "reqNew.budgetNotSure": "Not sure yet",
  "reqNew.timeline1Month": "Within 1 month",
  "reqNew.timeline1to3": "1-3 months",
  "reqNew.timeline3to6": "3-6 months",
  "reqNew.timeline6to12": "6-12 months",
  "reqNew.timelineFlexible": "Flexible / Exploration phase",

  "profile.title": "My Profile",
  "profile.subtitle": "Manage your personal information and preferences.",
  "profile.dashboard": "Dashboard",
  "profile.myRequests": "My Requests",
  "profile.signOut": "Sign Out",
  "profile.fullName": "Full Name",
  "profile.email": "Email",
  "profile.company": "Company",
  "profile.phone": "Phone",
  "profile.country": "Country",
  "profile.user": "User",
  "profile.admin": "Admin",
  "profile.emailCantChange": "Email cannot be changed.",
  "profile.saving": "Saving...",
  "profile.updated": "Profile Updated!",
  "profile.save": "Save Changes",
  "profile.selectCountry": "Select country",
  "profile.fullNamePlaceholder": "Your full name",
  "profile.companyPlaceholder": "Your company name",
  "profile.phonePlaceholder": "Your phone number",
  "profile.changePassword": "Change Password",
  "profile.currentPassword": "Current Password",
  "profile.newPassword": "New Password",
  "profile.confirmNewPassword": "Confirm New Password",
  "profile.passwordMin6": "Password must be at least 6 characters.",
  "profile.passwordsDontMatch": "Passwords don't match.",
  "profile.passwordChanged": "Your password has been changed successfully.",
  "profile.passwordChangeError": "Could not change password. Please check your current password.",
  "profile.deleteAccount": "Delete Account",
  "profile.deleteAccountTitle": "Are You Sure You Want to Delete Your Account?",
  "profile.deleteAccountDesc": "This action is irreversible. All your data, requests, and documents will be permanently deleted.",
  "profile.deleteAccountConfirm": "Delete My Account",
  "profile.deleteAccountSuccess": "Your account has been successfully deleted. Thank you for choosing us.",
  "profile.deleteAccountError": "Could not delete account. Please contact support.",
  "profile.changingPassword": "Changing...",
  "profile.passwordSection": "Security",
  "profile.dangerZone": "Danger Zone",
  "profile.passwordRequirements": "Must be at least 6 characters with uppercase letter and number.",

  "pa.countryLabel": "Country",
  "pa.loadingCountries": "Loading countries...",

  "pricing.badge": "Transparent Pricing",
  "pricing.title": "Choose Your Plan",
  "pricing.description": "Transparent pricing for every stage of your international expansion. No hidden fees, no surprises.",
  "pricing.all": "All Plans",
  "pricing.companyFormation": "Company Formation",
  "pricing.visaImmigration": "Visa & Immigration",
  "pricing.businessExpansion": "Business Expansion",
  "pricing.popular": "Most Popular",
  "pricing.getStarted": "Get Started",
  "pricing.noPlans": "No plans in this category yet.",
  "pricing.faqTitle": "Frequently Asked Questions",
  "pricing.faqDesc": "Everything you need to know about our pricing and payment process.",
  "pricing.contactSales": "Talk to Sales",
  "pricing.viewFAQ": "View All FAQs",

  "nav.pricing": "Pricing",

  "reqList.title": "My Requests",
  "reqList.subtitle": "Track and manage all your service requests.",
  "reqList.newRequest": "New Request",
  "reqList.profile": "Profile",
  "reqList.dashboard": "← Dashboard",
  "reqList.all": "All",
  "reqList.pending": "Pending",
  "reqList.inProgress": "In Progress",
  "reqList.completed": "Completed",
  "reqList.cancelled": "Cancelled",
  "reqList.loading": "Loading requests...",
  "reqList.loadingError": "Failed to load requests.",
  "reqList.tryAgain": "Try Again",
  "reqList.noRequests": "No requests found yet",
  "reqList.noRequestsFilter": "No requests matching this filter. Try a different status.",
  "reqList.noRequestsStart": "Start by creating your first service request.",
  "reqList.createRequest": "Create Request",
  "reqList.deleteRequest": "Delete Request",
  "reqList.deleteConfirm": "Are you sure you want to permanently delete this request?",
  "reqList.deleting": "Deleting...",
  "reqList.created": "Created",
  "reqList.serviceCompanyFormation": "Company Formation",
  "reqList.serviceVisaImmigration": "Visa & Immigration",
  "reqList.serviceBusinessExpansion": "Business Expansion",
  "reqList.serviceLegalConsulting": "Legal Consulting",

  "reqDetail.title": "Request Status",
  "reqDetail.details": "Request Details",
  "reqDetail.timeline": "Timeline",
  "reqDetail.backToRequests": "← My Requests",
  "reqDetail.profile": "Profile",
  "reqDetail.cancelRequest": "Cancel Request",
  "reqDetail.cancelling": "Cancelling...",
  "reqDetail.deleteRequest": "Delete Request",
  "reqDetail.deleting": "Deleting...",
  "reqDetail.deleteConfirm": "Are you sure you want to permanently delete this request? This action cannot be undone.",
  "reqDetail.notFound": "Request not found or access denied.",
  "reqDetail.loadError": "Failed to load request details.",
  "reqDetail.backToRequestsBtn": "Back to Requests",
  "reqDetail.loading": "Loading request...",
  "reqDetail.serviceType": "Service Type",
  "reqDetail.targetCountry": "Target Country",
  "reqDetail.companyName": "Company Name",
  "reqDetail.contactEmail": "Contact Email",
  "reqDetail.contactPhone": "Contact Phone",
  "reqDetail.budgetRange": "Budget Range",
  "reqDetail.timelineLabel": "Timeline",
  "reqDetail.description": "Description",
  "reqDetail.teamNotes": "Team Notes",
  "reqDetail.requestCreated": "Request Created",
  "reqDetail.statusPending": "Pending",
  "reqDetail.statusInProgress": "In Progress",
  "reqDetail.statusCompleted": "Completed",
  "reqDetail.statusCancelled": "Cancelled",
  "reqDetail.cancelledNotice": "This request has been cancelled.",
  "reqDetail.pendingDesc": "Your request has been received and is awaiting review.",
  "reqDetail.inProgressDesc": "Our team is actively working on your request.",
  "reqDetail.completedDesc": "Your request has been successfully completed.",

  "contact.whyLegalVioTitle": "Why LegalVio?",
  "contact.whyLegalVio.0": "Response guaranteed within 4 hours",
  "contact.whyLegalVio.1": "Service in 150+ countries",
  "contact.whyLegalVio.2": "{{count}}+ vetted law firms",
  "contact.whyLegalVio.3": "Support in 11 languages",
  "contact.whyLegalVio.4": "GDPR & KVKK compliant",

  "freeAnalysis.scope.title": "Analysis Scope",
  "freeAnalysis.scope.0.title": "Optimal Jurisdiction Analysis",
  "freeAnalysis.scope.0.desc": "Top 3 country recommendations for your business goals",
  "freeAnalysis.scope.1.title": "Company Type Recommendation",
  "freeAnalysis.scope.1.desc": "Tax advantages and compliance assessment",
  "freeAnalysis.scope.2.title": "Cost Projection",
  "freeAnalysis.scope.2.desc": "Setup and operational cost comparison",
  "freeAnalysis.scope.3.title": "Timeline Planning",
  "freeAnalysis.scope.3.desc": "Phased setup and expansion calendar",
  "freeAnalysis.scope.4.title": "Partner Matching",
  "freeAnalysis.scope.4.desc": "Law firm tailored to your professional needs",

  "careers.whyLegalVioTitle": "Why LegalVio?",
  "careers.whyLegalVio.0.title": "Global Impact",
  "careers.whyLegalVio.0.desc": "Gain international experience working on a platform operating in 80+ countries.",
  "careers.whyLegalVio.1.title": "Rapid Growth",
  "careers.whyLegalVio.1.desc": "Accelerate your career at a fast-growing LegalTech startup.",
  "careers.whyLegalVio.2.title": "Flexible Work",
  "careers.whyLegalVio.2.desc": "Maintain work-life balance with remote and hybrid work options.",
  "careers.whyLegalVio.3.title": "Innovation Culture",
  "careers.whyLegalVio.3.desc": "Develop innovative projects at the intersection of AI and legal technology.",

  "careers.heroBadge": "Join Our Team",
  "careers.heroTitle1": "Join the Team",
  "careers.heroTitle2": "That Changes the World",
  "careers.heroDesc": "We are a LegalTech platform shaping the future of global legal technology, serving in 11 languages and operating across 80+ countries.",
  "careers.heroStatLang": "Languages",
  "careers.heroStatCountries": "Countries",
  "careers.heroStatTeam": "Team Members",
  "careers.lifeBadge": "Life at LegalVio",
  "careers.openPositionsBadge": "Open Positions",
  "careers.openPositionsTitle": "Find the Right Role for You",
  "careers.noPositions": "No open positions in this category.",
  "careers.requirements": "Requirements",
  "careers.applyNow": "Apply for This Position",
  "careers.applyBadge": "Application",
  "careers.applyTitle": "Join Us",
  "careers.applyDesc": "Didn't find a suitable position? Apply anyway — we always review general applications.",
  "careers.successTitle": "Application Received!",
  "careers.successDesc": "We will review your application and contact you if it's deemed suitable.",
  "careers.newApplication": "New Application",
  "careers.formName": "Full Name *",
  "careers.formEmail": "Email *",
  "careers.formPhone": "Phone",
  "careers.formPosition": "Position *",
  "careers.formMessage": "Message / Cover Letter",
  "careers.formNamePh": "Your full name",
  "careers.formEmailPh": "you@email.com",
  "careers.formPhonePh": "+90 555 123 4567",
  "careers.formPositionPh": "Select position...",
  "careers.formMessagePh": "Tell us about yourself and why you want to join LegalVio...",
  "careers.formGeneral": "General Application",
  "careers.charCount": "characters",
  "careers.formRequired": "Please fill in full name, email, and position fields.",
  "careers.formCharLimit": "Message cannot exceed 500 characters.",
  "careers.formError": "Something went wrong. Please try again.",
  "careers.formSubmitting": "Submitting...",
  "careers.formSubmit": "Submit Application",
  "careers.breadcrumb": "Careers",

  "careers.heroStatLangVal": "11",
  "careers.heroStatCountriesVal": "80+",
  "careers.heroStatTeamVal": "50+",
}